<template>

  <div class="sidebar-info side-info">
      <div class="sidebar-logo-wrapper">
          <div class="row align-items-center">
              <div class="col-xl-6 col-8">
                  <div class="sidebar-logo">
                      <router-link :to="{ name: 'home' }"><img src="/asetet/logo_w.png" alt="logo-img"></router-link>
                  </div>
              </div>
              <div class="col-xl-6 col-4">
                  <div class="sidebar-close-wrapper text-end">
                      <button class="sidebar-close side-info-close"><i class="fal fa-times"></i></button>
                  </div>
              </div>
          </div>
      </div>
      <div class="sidebar-menu-wrapper fix">
          <div class="mobile-menu"></div>
      </div>
      <br>
      <br>
      
      <div class="sidebar-menu-wrapper fix">
        <div class="mobile-menu mean-container">
          <div class="mean-bar">
            <nav class="mean-nav">
              <ul>
                  <li><router-link :to="{ name: 'home' }">Fillimi</router-link></li>
                  <li><router-link :to="{ name: 'home', hash: '#services' }">Sherbimet</router-link></li>
                  <li><router-link :to="{ name: 'clients' }">Klientat</router-link></li>
                  <li><router-link :to="{ name: 'blog' }">Ngjarjet</router-link></li>
                  <li><router-link :to="{ name: 'contact' }">Kontakti</router-link></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="sidebar-contact-wrapper mt-40">

          <div class="sidebar-contact mb-40">
              <h4 class="sidebar-contact-title">Kontakti</h4>
              <span class="sidebar-address"><i class="fal fa-map-marker-alt"></i><span> Rr. Zhuj selmani PN</span> </span>
              <a href="tel:+38349200203"><i class="fal fa-phone"></i><span>+383 49 200 203</span></a>
              <a href="tel:+38345694444"><i class="fal fa-phone"></i><span>+383 45 694 444</span></a>
              <a href="mailto:info@gpro-ks.com" class="theme-3"><i class="fal fa-envelope"></i><span><span>info@gpro-ks.com</span></span></a>   
          </div>
      </div>
  </div>
  <div class="offcanvas-overlay"></div>
  <header>
      <div class="ns-header-area-4 ns-header-area-6">
          <div class="ns-header-navbar ns-header-navbar-5 container">
              <div class="row align-items-center justify-content-between">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-6">
                      <div class="ns-header-logo-2">
                          <router-link :to="{ name: 'home' }"><img src="/asetet/logo_w.png" style="width:70%"></router-link>
                      </div>
                  </div>
                  <div class="col-xl-9 col-lg-9 col-md-8 col-6">
                      <div class="ns-header-menu-2">
                          <nav class="ns-header-main-menu mobile-menu d-none d-lg-block" id="mobile-menu">
                              <ul>
                                  <li><router-link :to="{ name: 'home' }">Fillimi</router-link></li>
                                  <li><router-link :to="{ name: 'home', hash: '#services'}">Sherbimet</router-link></li>
                                  <li><router-link :to="{ name: 'clients' }">Klientat</router-link></li>
                                  <li><router-link :to="{ name: 'blog' }">Ngjarjet</router-link></li>
                                  <li><router-link :to="{ name: 'contact' }">Kontakti</router-link></li>
                              </ul>
                          </nav>
                          <div class="ns-header-menu-right">
                              <div class="menu-bar d-lg-none">
                                  <div class="navbar-sign side-toggle navbar-sign-white">
                                      <i class="fal fa-bars"></i>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </header>

</template>



<script>

    export default {

        data () {
            return {
                sherbimet: true,
                menuOpen: false
            }
        },


methods: {
    openMenu() {
        this.menuOpen = true;
        document.querySelector('.side-info').classList.add('info-open');
        document.querySelector('.offcanvas-overlay').classList.add('overlay-open');
    },

    closeMenu() {
        this.menuOpen = false;
        document.querySelector('.side-info').classList.remove('info-open');
        document.querySelector('.offcanvas-overlay').classList.remove('overlay-open');
    }
},


        mounted:function(){

            if(this.$route.name == 'home'){
               this.sherbimet = false;
            }else{
               this.sherbimet = true
            }



            if(this.$route.name == 'home'){
                this.sherbimet = false;
            } else {
                this.sherbimet = true;
            }

            // OPEN MENU (hamburger)
            document.querySelector('.side-toggle')
                .addEventListener('click', this.openMenu);

            // CLOSE MENU (X button)
            document.querySelector('.side-info-close')
                .addEventListener('click', this.closeMenu);

            // CLOSE BY OVERLAY CLICK
            document.querySelector('.offcanvas-overlay')
                .addEventListener('click', this.closeMenu);




        },


        components: {

        }


    }

</script>
